import type { ChatApiGetChatDialogsRequest, ChatDialogResponse } from '@/core/generated/api';
import type { ChatDialogData, ChatDialogSearchFilter, ChatDialogFilter } from './types';

const channelIds: Record<string, number> = {
    vox: 1,
    telegram: 2,
    vk: 3,
    avito: 4,
    max: 5
};

/** Проверяет соответствие диалога выбранным условиям поиска */
export const matchesChatDialogSearch = (
    state: ChatDialogData,
    dialog: ChatDialogResponse
): boolean => {
    const users = state.matchedAppUserIds;
    const channels = state.searchFilter.channels;

    const role = state.searchFilter.companionRole;
    const roleMatches = !role || users !== null || Boolean(dialog.companionAppUserId && dialog.companionRole?.id === role);

    // Live-событие может скрывать фамилию; состав поиска подтверждает сервер.
    const nameMatches = !state.searchFilter.companionName?.trim()
        || state.dialogs.some((item) => item.id === dialog.id);

    return nameMatches && roleMatches
        && (users === null || Boolean(dialog.companionAppUserId && users.includes(dialog.companionAppUserId)))
        && (channels.length === 0 || channels.includes(channelIds[dialog.channel?.id ?? '']));
};

/** Подготавливает только заданные условия поиска */
export const getChatDialogSearchQuery = (
    filter: ChatDialogSearchFilter
): Partial<ChatDialogSearchFilter> => (
    filter.companionRole || filter.filterPeople || filter.channels.length > 0 || filter.petName.trim() || filter.companionName?.trim()
        ? { ...filter }
        : {}
);

/** Проверяет наличие непрочитанных сообщений для вкладки «Ждут» */
export const matchesChatDialogTab = (
    filter: ChatDialogFilter,
    dialog: ChatDialogResponse,
): boolean => filter !== 'unread' || (dialog.unreadCount ?? 0) > 0;

/** Подготавливает серверные условия вкладки и поиска перед пагинацией */
export const getChatDialogListQuery = (
    state: Pick<ChatDialogData, 'filter' | 'searchFilter'>,
): ChatApiGetChatDialogsRequest => ({
    ...getChatDialogSearchQuery(state.searchFilter),
    unreadOnly: state.filter === 'unread',
});
